import React from 'react';

import type { PluginProps } from './../../ricos-types';

import { FileViewer } from '../viewer/file-viewer';

export const File: React.FC<PluginProps> = ({ settings = {}, componentData, node }) => {
  return (
    <FileViewer
      nodeId={node.attrs.id}
      componentData={componentData}
      settings={settings}
      isLoading={node.attrs.loading}
      tempDataPlaceHolder={node.attrs.tempData}
    />
  );
};
